import { useMemo } from "react";
import normalizeDateString from "../../../utils/common/normalizeDateString.js";

type MoodTimestamp = { seconds?: number } | string | Date;
type Mood = {
  uid: string;
  mood: string;
  duration: number;
  timestamp: MoodTimestamp;
};

/**
 * Maps moods for a given day to { [moodIndex]: duration } using feelingNames.
 */
export function useRelevantMoods(
  moods: Mood[],
  selectedDate: string | Date | undefined,
  userId: string | undefined,
  feelingNames: string[]
) {
  return useMemo<Record<number, number>>(() => {
    console.log("🔄 useRelevantMoods: Recalculating relevantMoods", {
      moodsLength: moods?.length || 0,
      selectedDate,
      userId,
      feelingNamesLength: feelingNames?.length || 0,
    });

    if (!moods?.length || !selectedDate || !userId) {
      console.log("🔄 useRelevantMoods: Early return - missing data");
      return {};
    }

    const target = normalizeDateString(selectedDate);
    console.log("🔄 useRelevantMoods: Target date:", target);

    const filtered = moods.filter(
      (m) => m.uid === userId && normalizeDateString(m.timestamp) === target
    );

    const map: Record<number, number> = {};
    filtered.forEach((m) => {
      const idx = feelingNames.findIndex(
        (label) => label.toLowerCase() === m.mood.toLowerCase()
      );
      if (idx !== -1) map[idx] = m.duration;
    });

    console.log("🔄 useRelevantMoods: Final map:", map);
    return map;
  }, [moods, selectedDate, userId, feelingNames]);
}
